import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import axios from 'axios';

import serverURI from 'config/URI';

import { toast } from 'react-toastify';

import { 
  Button, 
  Dialog, 
  // DialogActions,
  // DialogContent,
  // DialogContentText,
  // ListItemText, 
  ListItem, 
  List, 
  Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  MenuItem,
  Card,
  CardHeader,
  // CardActions,
  CardContent,
  Box,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
// import InfoIcon from '@material-ui/icons/Info';

// import DateFnsUtils from '@date-io/date-fns';
// import krLocale from "date-fns/locale/ko";
// import {
//   MuiPickersUtilsProvider,
//   KeyboardTimePicker,
//   KeyboardDatePicker,
// } from '@material-ui/pickers';

import { /*areas, groups,*/ statusContracts, typesCompany } from 'common/datas';
import { IsNoU } from 'common/utils';

import { DaumPostcode } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  card_header: {
    backgroundColor: theme.palette.card_header,
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListTimeTitle: {
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(2),
    width: '150px',
  },
  advertiseDefaultsTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
    //height: '42px',
  },
  registerListItemVolume: {
    //marginLeft: theme.spacing(2),
    width: '80px',
    //height: '40px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
  registerListItemWideInput: {
    //marginLeft: theme.spacing(2),
    width: '480px',
    //height: '40px',
  },

  // gridList: {
  //   width: 500,
  //   height: 450,
  // },
  // icon: {
  //   color: 'rgba(255, 255, 255, 0.54)',
  // },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const RegisterCompany = props => {

  const {
    className,
    openDialog,
    modeRegisterDialog,
    onClickCloseDialog,
    onClickSaveDialog,

    areas,
    groups,
    editCompany,
  } = props;

  const classes = useStyles();

  const [companyName, setCompanyName] = useState('');
  const [selectedArea, setSelectedArea] = useState('');
  const [selectedGroup, setSelectedGroup] = useState('');
  const [selectedContract, setSelectedContract] = useState(statusContracts[0].value);
  const [selectedCompanyType, setSelectedCompanyType] = useState('개인');
  
  const [manager, setManager] = useState('');
  const [telephone, setTelephone] = useState('');
  const [mobile, setMobile] = useState('');
  const [email, setEmail] = useState('');

  const [zipcode, setZipcode] = useState('');
  const [address1, setAddress1] = useState('');
  const [address2, setAddress2] = useState('');

  const [areaGroups, setAreaGroups] = useState([]);

  const handleChangeArea = (e) => {
    let newAreaGroups = groups.filter(group => group.area === e.target.value);
    //console.log('new groups ->');
    //console.log(newAreaGroups);
    setAreaGroups(newAreaGroups);
    setSelectedGroup('');
    setSelectedArea(e.target.value)
  }

  const handleChangeGroup = event => {
    setSelectedGroup(event.target.value);
  };

  const handleChangeContract = event => {
    setSelectedContract(event.target.value);
  };

  const handleChangeCompanyType = event => {
    setSelectedCompanyType(event.target.value);
  };

  const handlePostcodeComplete = (data) => {
    //console.log(data);
    let fullAddress = data.address;
    let extraAddress = ''; 

    if (!IsNoU(data.zonecode)) {
      setZipcode(data.zonecode);
    }
    
    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname;
      }
      if (data.buildingName !== '') {
        extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
      }
      fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
      setAddress1(fullAddress);
    }

    //console.log(fullAddress);  // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
  };

  const initializeDaum = () => {
    window.daum.postcode.load(() => {
      const Postcode = new window.daum.Postcode({
        oncomplete: function oncomplete(data) {
          handlePostcodeComplete(data);
          //if (comp.props.autoClose) comp.setState({ display: 'none' });
        },
        // onsearch: comp.props.onSearch,
        // onresize: function onresize(size) {
        //   if (comp.props.autoResize) comp.setState({ height: size.height });
        // },
        // alwaysShowEngAddr: comp.props.alwaysShowEngAddr,
        // animation: comp.props.animation,
        // autoMapping: comp.props.autoMapping,
        // autoResize: comp.props.autoResize,
        // height: comp.props.height,
        // hideEngBtn: comp.props.hideEngBtn,
        // hideMapBtn: comp.props.hideMapBtn,
        // maxSuggestItems: comp.props.maxSuggestItems,
        // pleaseReadGuide: comp.props.pleaseReadGuide,
        // pleaseReadGuideTimer: comp.props.pleaseReadGuideTimer,
        // shorthand: comp.props.shorthand,
        // showMoreHName: comp.props.showMoreHName,
        // submitMode: comp.props.submitMode,
        // theme: comp.props.theme,
        // useSuggest: comp.props.useSuggest,
        // width: comp.props.width,
        // focusInput: comp.props.focusInput,
        // focusContent: comp.props.focusContent,
      });

      Postcode.open();

      //Postcode.embed(this.wrap, { q: this.props.defaultQuery, autoClose: this.props.autoClose });
    });
  };

  const handleDaumError = (error) => {
    error.target.remove();
    //this.setState({ error: true });
    //console.log("err -> ");
  };

  const getCheckedCompany = (name, area, group) => {
    return axios({
      method: 'post',
      url: `${serverURI}/api/company/taxi/check`,
      data: {
        name: name, area: area, group: group
      }
    });
  }

  useEffect(() => {
    //console.log("componentDidMount");

    const scriptId = 'daum_postcode_script';
    const isExist = !!document.getElementById(scriptId);

    if (!isExist) {
      const script = document.createElement('script');
      script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';//this.props.scriptUrl;
      script.onload = () => {};//initializeDaum();
      script.onerror = error => handleDaumError(error);
      script.id = scriptId;
      document.body.appendChild(script);
    } 
    else {
      //initializeDaum();
    }

    if (!IsNoU(editCompany))
    {
      setCompanyName(editCompany.name);
      setSelectedArea(editCompany.area);
      setSelectedGroup(editCompany.group);
      setSelectedContract(editCompany.contract);
      setSelectedCompanyType(editCompany.type);
  
      setManager(editCompany.manager);
      setTelephone(editCompany.tel);
      setMobile(editCompany.mobile);
      setEmail(editCompany.email);

      setZipcode(editCompany.zipcode);
      setAddress1(editCompany.address1);
      setAddress2(editCompany.address2);
    }
    else {
      setCompanyName('');
      // if (!IsNoU(areas) && areas.length > 0)
      // {
      //   setSelectedArea(areas[0].name);
      // }
      // else {
        setSelectedArea('');
      // }
      // if (!IsNoU(groups) && groups.length > 0)
      // {
      //   setSelectedGroup(groups[0].name);
      // }
      // else {
        setSelectedGroup('');
      // }
      setSelectedContract(statusContracts[0].value);
      setSelectedCompanyType(typesCompany[0].value);
  
      setManager('');
      setTelephone('');
      setMobile('');
      setEmail('');

      setZipcode('');
      setAddress1('');
      setAddress2('');
    }

  }, [editCompany]); // empty-array means don't watch for any updates

  // const renderDaumPostcode = (
  //   <DaumPostcode
  //     openDialog={openDaumPostcode}
  //     onComplete={handlePostcodeComplete}
  //     { ...props }
  //   />
  // );

  // useEffect(() => {
  //   console.log("componentDidUpdate areas -> " + areas.length);

  //   if (!IsNoU(areas) && areas.length > 0)
  //   {
  //     setSelectedArea(areas[0].name);
  //   }
  //   else {
  //     setSelectedArea('');
  //   }

  // }, [areas]); // empty-array means don't watch for any updates

  // useEffect(() => {
  //   console.log("componentDidUpdate groups -> " + groups.length);

  //   if (!IsNoU(groups) && groups.length > 0)
  //   {
  //     setSelectedGroup(groups[0].name);
  //   }
  //   else {
  //     setSelectedGroup('');
  //   }

  // }, [groups]); // empty-array means don't watch for any updates

  return (
    <div>
      <Dialog fullScreen open={openDialog} onClose={onClickCloseDialog} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h5" className={classes.title} color="inherit">
              택시회사
            </Typography>
            <Button autoFocus color="inherit" onClick={async () => {

                if (IsNoU(companyName) || companyName.length <= 0) {
                  toast("택시회사명을 입력하세요.");
                  return ;
                }

                if (IsNoU(selectedArea) || selectedArea.length <= 0) {
                  toast("권역을 입력하세요.");
                  return ;
                }

                if (IsNoU(selectedGroup) || selectedGroup.length <= 0) {
                  toast("그룹을 입력하세요.");
                  return ;
                }

                if (IsNoU(selectedContract) || selectedContract.length <= 0) {
                  toast("계약상태를 선택하세요.");
                  return ;
                }

                if (IsNoU(selectedCompanyType) || selectedCompanyType.length <= 0) {
                  toast("사업장구분을 선택하세요.");
                  return ;
                }

                const res = await getCheckedCompany(companyName, selectedArea, selectedGroup);
                //console.log(res);
                const checked_company = res.data.checked_company;
                if (!checked_company) {
                  toast(companyName+" 대리점 명이 존재합니다..");
                  return ;
                }

                const newCompany = {
                  name: companyName,
                  area: selectedArea,
                  group: selectedGroup,
                  contract: selectedContract,
                  type: selectedCompanyType,
                  manager: manager,
                  tel: telephone,
                  mobile: mobile,
                  email: email,
                  zipcode: zipcode,
                  address1: address1,
                  address2: address2,
                  devices: 0,
                  reg_at: new Date(),
                };

                if (!IsNoU(editCompany))
                  newCompany.id = editCompany.id;

                onClickSaveDialog(newCompany);
              }}>
              저장
            </Button>
          </Toolbar>
        </AppBar>

        <List>
          <ListItem>
            <Card
              className={clsx(classes.card_root, className)}
            >
              <CardHeader
                className={classes.card_header}
                title={modeRegisterDialog ? '택시회사 등록' : '택시회사 수정'}
                subheader='*표시는 필수 항목'
              />
              <CardContent className={classes.content}>
                <List>
                  <ListItem className={classes.listitem_align}>
                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-company-name"
                      label="택시회사 명"
                      required
                      placeholder="택시회사 명을 입력하세요..."
                      //variant="outlined" 
                      value={companyName}
                      onChange={event=> setCompanyName(event.target.value)}
                      margin="dense"/>

                  </ListItem>
                  <Divider />
                  <ListItem>
                  {/* <SelectAreaGroup 
                    areas={areas}
                    groups={areaGroups}
                    valueArea={selectedArea}
                    onChangeArea={handleChangeArea}
                    valueGroup={selectedGroup}
                    onChangeGroup={e => setSelectedGroup(e.target.value)}
                    /> */}
                    <TextField
                      className={classes.registerListItemInput}
                      id="outlined-select-area"
                      label='권역'
                      required
                      select
                      value={selectedArea}
                      onChange={handleChangeArea}
                      helperText=""
                      //variant="outlined"
                      margin="dense"
                    >
                      {areas.map(option => (
                        <MenuItem key={option.name} value={option.name}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>

                    <Box p={2}></Box>
                    <TextField
                      className={classes.registerListItemInput}
                      id="outlined-select-group"
                      label='그룹'
                      required
                      select
                      value={selectedGroup}
                      onChange={handleChangeGroup}
                      helperText=""
                      //variant="outlined"
                      margin="dense"
                      helperText="* 권역선택후 선택하세요"
                    >
                      {areaGroups.map(option => (
                        <MenuItem key={option.name} value={option.name}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <TextField
                      className={classes.registerListItemInput}
                      id="outlined-select-company-contract"
                      label="계약상태"
                      required
                      select
                      value={selectedContract}
                      onChange={handleChangeContract}
                      //variant="outlined"
                      margin="dense"
                    >
                      {statusContracts.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>

                    <Box p={2}></Box>

                    <TextField
                      className={classes.registerListItemInput}
                      id="outlined-select-company-client"
                      label="사업장 구분"
                      required
                      select
                      value={selectedCompanyType}
                      onChange={handleChangeCompanyType}
                      //variant="outlined"
                      margin="dense"
                    >
                      {typesCompany.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-company-manager"
                      label="거래담당자"
                      placeholder="거래담당자를 입력하세요..."
                      //variant="outlined" 
                      value={manager}
                      onChange={event=> setManager(event.target.value)}
                      margin="dense"/>

                      <Box p={2}/>

                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-company-phone"
                      label="전화번호"
                      placeholder="전화번호를 입력하세요..."
                      //variant="outlined" 
                      value={telephone}
                      onChange={event=> setTelephone(event.target.value)}
                      margin="dense"/>

                      <Box p={2}/>

                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-company-mobile"
                      label="핸드폰"
                      placeholder="핸드폰 번호를 입력하세요..."
                      //variant="outlined" 
                      value={mobile}
                      onChange={event=> setMobile(event.target.value)}
                      margin="dense"/>
                  </ListItem>
                  <ListItem>
                    <Box p={2} />
                    <Typography
                      className={classes.registerListItemInput}
                      color="textSecondary"
                      gutterBottom
                    >
                    </Typography>

                    <TextField 
                      className={classes.registerListItemWideInput}
                      id="outlined-basic-reg-company-email"
                      label="메일"
                      placeholder="메일 주소를 입력하세요..."
                      //variant="outlined" 
                      value={email}
                      onChange={event=> setEmail(event.target.value)}
                      margin="dense"/>
                  </ListItem>
                  <Divider />
                  <ListItem>
                    <TextField 
                      className={classes.registerListItemInput}
                      id="outlined-basic-reg-company-zipcode"
                      label="우편번호"
                      //variant="outlined" 
                      value={zipcode}
                      onChange={event=> setZipcode(event.target.value)}
                      margin="dense"/>
                    <Box p={2} />
                    <Button
                      variant="contained"
                      onClick={ () => initializeDaum() }
                    >
                      우편번호 찾기
                    </Button>

                  </ListItem>
                  <ListItem>
                    <TextField 
                      className={classes.registerListItemWideInput}
                      id="outlined-basic-reg-company-address1"
                      label="주소"
                      //variant="outlined" 
                      value={address1}
                      onChange={event=> setAddress1(event.target.value)}
                      margin="dense"/>
                  </ListItem>

                  <ListItem>
                    <TextField 
                      className={classes.registerListItemWideInput}
                      id="outlined-basic-reg-company-address2"
                      label="상세 주소"
                      //variant="outlined" 
                      value={address2}
                      onChange={event=> setAddress2(event.target.value)}
                      margin="dense"/>
                  </ListItem>
                  <Divider />
                </List>
              </CardContent>
            </Card>

          </ListItem>
        </List>

      </Dialog>
    </div>
  );
}

export default RegisterCompany;
